import { inject, Injectable, signal } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, combineLatest, first, Observable, Subject, switchMap } from 'rxjs';
import { BaseService } from '../../services/base.service';
import { MultiFactorAuthService } from '../../services/multi-factor-auth.service';
import { AddCardComponent } from './add-card.component';
import { AddNewPaymentMethod } from '../../models/payment-info.model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { FormName } from '../../config/ga.config';

@Injectable({
  providedIn: 'root',
})
export class AddCardService {
  private readonly user = inject(UserAccountFacade);
  private readonly csAgentAuthService = inject(CsAgentAuthService);
  private readonly mfaService = inject(MultiFactorAuthService);

  public cardDetails = new BehaviorSubject<any>(false);
  public cardAdded = new BehaviorSubject<AddNewPaymentMethod | false>(false);
  public cardCloseError = new Subject<any>();

  isMfaPopupLoading = false;

  constructor(private readonly baseService: BaseService, protected modalService: NgbModal) {
  }

  public addCard(cardToken): Observable<AddNewPaymentMethod> {
    return combineLatest([
      this.csAgentAuthService.isCustomerEmulated(),
      this.user.get()
    ]).pipe(
      first(([isCustomerEmulated, user]) => !!user),
      switchMap(([isCustomerEmulated, user]) => {
        return this.baseService.post(`/users/${isCustomerEmulated ? user.uid : 'current'}/paymentdetails`, cardToken);
      }),
      first(Boolean)
    );
  }

  addCardWithMFA(forCheckingAccounts = false, isProfilePage = false, forceDefaultPayment = false): void {
    if (this.isMfaPopupLoading) {
      return;
    }

    this.isMfaPopupLoading = true;
    const processType = 'add';
    const process = 'mfa-auth';
    const triggerLocation = `${ processType }-${ process }`;

    this.mfaService.multiFactorAuth(triggerLocation, null, FormName.ADD_ECHECK_ACCOUNT);
    this.mfaService.multiFactorAuthResult
      .pipe(
        first(Boolean),
      )
      .subscribe(res => {
        this.isMfaPopupLoading = false;

        if (!res?.status) {
          return;
        }

        const modRef = this.modalService.open(AddCardComponent, { windowClass: 'add-card-modal' });

        modRef.componentInstance.iframeHeight = signal(forCheckingAccounts ? 385 : 650);

        modRef.componentInstance.forCheckingAccounts = forCheckingAccounts;
        modRef.componentInstance.isProfilePage = signal(isProfilePage);
        modRef.componentInstance.forceDefaultPayment = signal(forceDefaultPayment);
      });
  }
}
